
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetAllTestSlates } from '../vlp/services/TestLibService';

// Async thunk to load slates
export const fetchSlateLib = createAsyncThunk(
  'slateLib/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetAllTestSlates();      
      const slates = response && response.results ? response.results : response;
      return slates || [];
    } catch (err) {
      return rejectWithValue(err?.message || 'Failed to fetch slate library');
    }
  }
);

const initialState = {
  data: [],          
  status: 'idle',    
  error: null,
};

const slateLibSlice = createSlice({
  name: 'slateLib',
  initialState,
  reducers: {
    // Optional local setters for manual updates
    setSlateLib: (state, action) => {
      state.data = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearSlateLib: (state) => {
      state.data = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSlateLib.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSlateLib.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchSlateLib.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { setSlateLib, clearSlateLib } = slateLibSlice.actions;

// Selectors
export const selectSlateLibData = (state) => state.slateLib.data;
export const selectSlateLibStatus = (state) => state.slateLib.status;
export const selectSlateLibError = (state) => state.slateLib.error;

export default slateLibSlice.reducer;